import { AcademicLevelType } from "../../types/AcademicLevelType";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import {  get, post, put } from "../../utils/axios-config";

import { ACADEMIC_LEVELS } from "../../utils/constants";


export const createAcademicLevel = async (data: AcademicLevelType) => {
    return await post<AcademicLevelType, string>(ACADEMIC_LEVELS, data);
};

export const updateAcademicLevel = async (data: AcademicLevelType) => {
    return await put<AcademicLevelType, string>(ACADEMIC_LEVELS, data);
};

export const getAcademicLevels = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${ACADEMIC_LEVELS}?${queryParams.toString()}`;
    return await get<PagedResultsType<AcademicLevelType>>(url);
};
